import { AdministrationMessageItem, AdministrationMessageItemTranslation } from '../types-store';

export const getTranslationForLanguage = (
  message: AdministrationMessageItem,
  languageId: number
): AdministrationMessageItemTranslation =>
  message && message.translations && message.translations
    .find(
      t => t.language === languageId
    ) || {
    language: languageId,
    subject: undefined,
    message: undefined
  };
